export const forSaveAndNext = (state: any) => {
    let currentStepArr = JSON.parse(JSON.stringify(state.stepArr));
    currentStepArr[state.currentStep] = {
        ...currentStepArr[state.currentStep],
        active: false,
        completed: true
    };
    if (currentStepArr[state.currentStep + 1]) {
        currentStepArr[state.currentStep + 1] = {
            ...currentStepArr[state.currentStep + 1],
            active: true,
            completed: false
        };
    }
    return currentStepArr;
};

export const forGoingPreviousStep = (state: any) => {
    let currentStepArr = JSON.parse(JSON.stringify(state.stepArr));
    currentStepArr[state.currentStep] = {
        ...currentStepArr[state.currentStep],
        active: false,
        completed: true
    };
    currentStepArr[state.currentStep - 1] = {
        ...currentStepArr[state.currentStep - 1],
        active: true,
        completed: false
    };
    return currentStepArr;
};

export const forInitOnRoute = (state: any, action: any) => {
    let currentStepArr = JSON.parse(JSON.stringify(state.stepArr));
    let isGoingBack = false;
    if (action.stepNumber <= state.currentStep)
        isGoingBack = true;
    else
        isGoingBack = false;
    for (let i = 0; i < currentStepArr.length; i++) {
        if (i < action.stepNumber) {
            currentStepArr[i] = {
                ...currentStepArr[i],
                active: false,
                completed: true
            };
        } else if (i === action.stepNumber) {
            currentStepArr[i] = {
                ...currentStepArr[i],
                active: true,
                completed: false
            };
        } else if (i > action.stepNumber) {
            currentStepArr[i] = {
                ...currentStepArr[i],
                active: false,
                completed: false
            };
        }
    }

    return {
        isGoingBack, stepArr: currentStepArr
    }
};

export const forSaveSelectionValue = (state: any, action: any) => {
    let currentStepArr = JSON.parse(JSON.stringify(state.stepArr));
    if(currentStepArr[state.currentStep].title == "Base Vehicle" && (currentStepArr[state.currentStep].other !== action.otherValue || currentStepArr[state.currentStep].value !== action.selectionValue) && currentStepArr[state.currentStep].value !== "" && currentStepArr[state.currentStep].title != "Value Added Services") {
        return {
            showEditModal: true,
            newSelectedValue: action.selectionValue,
            newSelectedOther: action.otherValue
        }
    }else if (currentStepArr[state.currentStep].value !== action.selectionValue && currentStepArr[state.currentStep].value !== "" && currentStepArr[state.currentStep].title != "Value Added Services") {
        return {
            showEditModal: true,
            newSelectedValue: action.selectionValue,
            newSelectedOther: action.otherValue
        }
    } else {
        currentStepArr[state.currentStep] = {
            ...currentStepArr[state.currentStep],
            value: action.selectionValue,
            other: action.otherValue
        }
        return {
            showEditModal: false,
            stepArr: currentStepArr
        }
    }

    // return currentStepArr;
}

export const forSaveSelectionValueOnModal = (state: any, action: any) => {
    let currentStepArr = JSON.parse(JSON.stringify(state.stepArr));
    if(currentStepArr[state.currentStep].title == "Base Vehicle"){
        if (currentStepArr[state.currentStep].other !== action.otherValue) {
            for (let i = state.currentStep + 1; i < currentStepArr.length; i++) {
                currentStepArr[i] = {
                    ...currentStepArr[i],
                    value: "",
                    other: ""
                }
            }
        }
    }else{
        if (currentStepArr[state.currentStep].value !== action.selectionValue) {
            for (let i = state.currentStep + 1; i < currentStepArr.length; i++) {
                currentStepArr[i] = {
                    ...currentStepArr[i],
                    value: "",
                    other: ""
                }
            }
        }
    }
    
    currentStepArr[state.currentStep] = {
        ...currentStepArr[state.currentStep],
        value: action.selectionValue,
        other: action.otherValue
    }
    return {
        stepArr: currentStepArr,
        showEditModal: false,
        newSelectedValue: null,
        newSelectedOther: null
    }
}

export const forPuttingValueOnStep = (state: any, action: any) => {
    let currentStepArr = JSON.parse(JSON.stringify(state.stepArr));
    currentStepArr[action.stepNumber] = {
        ...currentStepArr[action.stepNumber],
        active: false,
        completed: false,
        value: action.selectionValue
    }
    return currentStepArr;
}

export const forPuttingValueOnStepOther = (state: any, action: any) => {
    let currentStepArr = JSON.parse(JSON.stringify(state.stepArr));
    currentStepArr[action.stepNumber] = {
        ...currentStepArr[action.stepNumber],
        other: action.otherValue
    }
    return currentStepArr;
}
